import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Content } from './style';
import Header from '../../components/Header';
import Keyboard from '../../components/Keyboard';
import Layout from '../../commons/layout';

class Home extends Component {
  constructor(props) {
    super(props);
    this.goComandas = this.goComandas.bind(this);
  }

  goComandas() {
    this.props.history.push('/comanda');
  }

  render() {
    return (
      <Layout>
        <Header
          center
          title="Terminal Livre"
          subtitle="Informe uma comanda para abrir ou adicionar"
        />
        <Content>
          <Keyboard callBack={this.goComandas} />
        </Content>
      </Layout>
    );
  }
}

export default withRouter(Home);
